import axios from 'axios';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import jwt from 'jsonwebtoken';
import moment from 'moment';
import { STAR_PRODUCT_CODE } from '../../common/constant/star_product_code';
import { STAR_STATUS_CODE } from '../../common/constant/star_status_code';
import service from '../services/index';
import {
  MAP_PROPOSAL_STATUSES,
  PRODUCTS_GROUPING,
  STATUS_PROPOSTA,
} from './constants';

export default {
  formatStarNumber(id, typeProduct, typePolicy) {
    if (id.length > 6) {
      return id;
    }

    const sequencial = id.toString().padStart(6, '0');
    return `${STAR_PRODUCT_CODE[typeProduct]}.${STAR_STATUS_CODE[typePolicy]}.01.${sequencial}`;
  },
  isAlreadyTransmitted(statusId) {
    const alreadyTransmittedStatuses = [
      STATUS_PROPOSTA.RECUSADA.id,
      STATUS_PROPOSTA.AGUARDANDO_APROVACAO.id,
      STATUS_PROPOSTA.FINALIZADO.id,
      STATUS_PROPOSTA.PENDENTE.id,
      STATUS_PROPOSTA.EM_PROCESSO_VISTORIA.id,
      STATUS_PROPOSTA.EM_PRE_ANÁLISE.id,
      STATUS_PROPOSTA.AGUARDANDO_DADOS_CARTAO.id,
      STATUS_PROPOSTA.AGUARDANDO_DOCUMENTACAO.id,
      STATUS_PROPOSTA.APOLICE_CANCELADA.id,
      STATUS_PROPOSTA.AGUARDANDO_ESTORNO.id,
      STATUS_PROPOSTA.ESTORNADA.id,
      STATUS_PROPOSTA.VISTORIA_EXPIRADA.id,
      STATUS_PROPOSTA.AGUARDANDO_PAGAMENTO.id,
    ];

    return alreadyTransmittedStatuses.includes(statusId);
  },
  escondeEmail(email) {
    var maskedEmail = email.replace(/([^@.])/g, '*').split('');
    var previous = '';
    for (let i = 0; i < maskedEmail.length; i++) {
      if (i <= 1 || previous == '.' || previous == '@') {
        maskedEmail[i] = email[i];
      }
      previous = email[i];
    }
    return maskedEmail.join('');
  },

  escondeCelular(celular) {
    var arddd = celular.split(')');
    var ddd = arddd[0] + ')';
    var arrFim = celular.split('-');
    var fimCelular = arrFim[1];
    return ddd + '9****-' + fimCelular;
  },

  /**
   * Substitui um trecho de uma string por outro
   * @param {string} string
   * @param {string} search
   * @param {string} replace
   * @return {string}
   */
  replaceAll(string, search, replace) {
    return string.split(search).join(replace);
  },

  getContractedProductsWithDetails(
    coverageContracted,
    allCoverages,
    isService,
  ) {
    const coverages = [];
    coverageContracted.forEach((contracted) => {
      const detailedProduct = allCoverages.details
        .filter((detail) => {
          return isService !== undefined
            ? detail.isService === isService
            : detail;
        })
        .find((detail) => detail.id === contracted.id);
      if (detailedProduct) {
        coverages.push({ ...detailedProduct, ...contracted });
      }
    });
    return coverages;
  },

  getEndorsementContractedProductsWithDetails(
    coverageContracted,
    allCoverages,
    isService,
  ) {
    const coverages = [];

    coverageContracted.forEach((contracted) => {
      const filteredDetails = allCoverages.details.filter((detail) => {
        return isService !== undefined
          ? detail.isService === isService
          : detail;
      });

      let detailedProduct = filteredDetails.find(
        (detail) => detail.id === contracted.id,
      );

      if (!detailedProduct) {
        detailedProduct = filteredDetails.find(
          (detail) =>
            Array.isArray(detail.overlapAnotherCoverages) &&
            detail.overlapAnotherCoverages.includes(contracted.id),
        );
      }

      if (detailedProduct) {
        coverages.push({ ...detailedProduct, ...contracted });
      }
    });

    return coverages;
  },

  getProposalStatusName(statusId) {
    return MAP_PROPOSAL_STATUSES[statusId] || statusId;
  },

  getStatusColor(data) {
    switch (data) {
      case STATUS_PROPOSTA.EM_TRANSMISSAO.id:
      case STATUS_PROPOSTA.EM_TRANSMISSAO.name:
        return 'success';
      case STATUS_PROPOSTA.AGUARDANDO_APROVACAO.id:
      case STATUS_PROPOSTA.AGUARDANDO_APROVACAO.name:
        return 'blue';
      case STATUS_PROPOSTA.RECUSADA.id:
      case STATUS_PROPOSTA.RECUSADA.name:
        return 'danger';
      case STATUS_PROPOSTA.PENDENTE.id:
      case STATUS_PROPOSTA.PENDENTE.name:
      case STATUS_PROPOSTA.PROCESSANDO_PAGAMENTO.id:
      case STATUS_PROPOSTA.PROCESSANDO_PAGAMENTO.name:
        return 'warning';
      case STATUS_PROPOSTA.EM_PROCESSO_VISTORIA.id:
      case STATUS_PROPOSTA.EM_PROCESSO_VISTORIA.name:
        return 'primary';
      case STATUS_PROPOSTA.EM_PRE_ANÁLISE.id:
      case STATUS_PROPOSTA.EM_PRE_ANÁLISE.name:
      case STATUS_PROPOSTA.AGUARDANDO_PAGAMENTO.id:
      case STATUS_PROPOSTA.AGUARDANDO_PAGAMENTO.name:
      case STATUS_PROPOSTA.AGUARDANDO_DADOS_CARTAO.id:
      case STATUS_PROPOSTA.AGUARDANDO_DADOS_CARTAO.name:
        return '#7B49E7';

      case STATUS_PROPOSTA.FINALIZADO.id:
      case STATUS_PROPOSTA.FINALIZADO.name:
        return 'dark';
      case STATUS_PROPOSTA.COTACAO_ABERTA.id:
      case STATUS_PROPOSTA.COTACAO_ABERTA.name:
        return '#007214';
      default:
        return 'danger';
    }
  },
  formataMsParaData(ms) {
    const d = moment.duration(ms);

    if (d.days() > 0) {
      // acima de 24 horas formato "XX dias e YY horas"
      let horasStr = '';
      if (d.hours() > 0)
        horasStr = `e ${d.hours()} hora${d.hours() > 1 ? 's' : ''}`;

      return `${d.days()} dia${d.days() > 1 ? 's' : ''} ${horasStr}`;
    } else {
      // abaixo de 24 horas formato 23:59:59
      return `${d.hours().toString().padStart(2, '0')}:${d
        .minutes()
        .toString()
        .padStart(2, '0')}:${d.seconds().toString().padStart(2, '0')}`;
    }
  },

  calculaIdade(dataNascimento) {
    //Recebe como parâmetro uma string com o formato "DD/MM/AAAA"
    const partesData = dataNascimento.split('/');
    const dataNascimentoFormatada = new Date(
      partesData[2],
      partesData[1] - 1,
      partesData[0],
    );
    const dataAtual = new Date();

    const idadeMilissegundos = dataAtual - dataNascimentoFormatada;
    const idadeAnos = Math.floor(idadeMilissegundos / 31557600000); // aproximadamente o número de milissegundos em um ano

    return idadeAnos;
  },

  /**
   * Formata uma data passa com a biblioteca moment.JS
   * @param {*} data data no formato ISO 8601
   * @param {*} formato formato que se quer formatar a data. Padrão DD-MM-YYYY
   * @param {number} add numero de horas que se quer adicionar(valor positivo) ou remover(valor negativo) da hora
   * @returns {string}
   */
  formataDataMomentJS(data, formato = 'DD/MM/YYYY', add = 0) {
    return moment(data).add(add, 'hours').format(formato);
  },

  /**
   * Formata um objeto data ISO8601 para retornar uma string no padrão DD/MM/AAAA HH:mm
   * @param {*} dataObject Objeto data
   * @param {boolean} horas monstrar as horas?
   * @return {string}
   */
  formataDataHoraPadraoBR(dataObject, horas = true) {
    if (!dataObject) {
      return;
    }

    const stringData =
      dataObject instanceof Date ? dataObject.toISOString() : dataObject;

    let data, hora;

    if (stringData.includes('T')) {
      [data, hora] = stringData.split('T');
      hora = hora.split('.')[0];
    } else {
      [data, hora] = stringData.split(' ');
    }

    data = data.split('-').reverse().join('/');

    if (horas && hora) {
      return data + ' ' + hora.slice(0, 5);
    }

    return data;
  },

  formatDateAndHour(date) {
    if (!date) {
      return '';
    }

    return moment(date).format('DD/MM/YYYY HH:mm');
  },

  isObjectEmpty(value) {
    const isEmpty =
      value && Object.keys(value).length && value.constructor === Object;

    return !isEmpty;
  },

  /**
   * idsEmpresas = recebe array ou um inteiro
   */
  verificaEmpresaBemProtege(idEmpresa) {
    if (!idEmpresa) return;
    const idsEmpresaBemProtege = this.idsEmpresaBemProtege();

    const idsEmpresas = Array.isArray(idEmpresa) ? [...idEmpresa] : [idEmpresa];
    let isEmpresaBemProtege = false;

    idsEmpresas.forEach((id) => {
      const isBP = idsEmpresaBemProtege.includes(+id);
      if (isBP) isEmpresaBemProtege = true;
    });

    return isEmpresaBemProtege;
  },

  idsEmpresaBemProtege() {
    return [4, 116, 117, 118, 119];
  },

  async getIP() {
    try {
      const { data } = await axios.get('https://api.ipify.org?format=json');
      return data.ip;
    } catch (error) {
      return 'Não foi possível localizar o ip';
    }
  },

  formataReal(valor) {
    if (!valor && valor !== 0) {
      return;
    }

    return Number(valor).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  },

  formataRealTruncated(valor) {
    if (isNaN(valor)) {
      return 'R$ 0,00';
    }

    const truncatedValue = Math.floor(valor * 100) / 100;

    return truncatedValue.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  },

  /**
   * Preenche um array de options de um v-select com os dados de um model
   * @param {string} model model dos dados
   * @param {array} array array a ser preenchido
   * @param {string} campoDescricao nome da variavel no model a ser usado na label do select
   * @param {string} campoPK nome da variavel que guarda o id do model
   * @param {object} extraParams :pk/:id,
   * @param {boolean} all trazer registros com deletedAt?
   */
  async buscaDadosSelects(
    model,
    array,
    campoDescricao,
    campoPK,
    extraParams = undefined,
    all = false,
  ) {
    const list = all ? 'listAll' : 'list';

    try {
      const res = await service.getAll(
        'g',
        {},
        `${model}/${list}/${extraParams ? extraParams : ''}`,
      );
      res.data.forEach((element) => {
        array.push({
          id: element[campoPK],
          label: element[campoDescricao],
        });
      });

      array.sort(function (a, b) {
        return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
      });

      return array;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Organiza uma lista retornada pelo back-end em dias de acordo com uma coluna data no formato ISO 8601
   * @param {object} dados Lista de retorna pelo back-end
   * @returns {array}
   */
  organizarEmDias(dados) {
    const dias = [];
    for (const dado of dados) {
      const dataFormatada = dado.dataHoraFormatada || dado.createdAt;
      const [data, hora] = dataFormatada.split(' ');
      const index = dias.findIndex((dado) => dado && dado.data === data);

      const newDado = {
        ...dado,
        hora: hora ? hora.slice(0, 5) : hora,
      };
      if (index === -1) {
        dias.push({ data, dados: [newDado] });
      } else {
        dias[index].dados.push(newDado);
      }
    }

    return dias;
  },

  /**
   * Retorna a hora extraida de uma string de data no formato ISO 8601
   * @param {string} data
   * @returns {string}
   */
  pegarHora(data) {
    return data.slice(11, 16);
  },

  /**
   * Pega, decodifica e retorna os dados do token, caso ele exista
   * @param {object} localStorage
   * @returns {object}
   */
  getDecoded(localStorage) {
    const token = localStorage.getItem('user-token');

    if (token) {
      const decoded = jwt.decode(token);
      return {
        idEmpresa: decoded.id_empresa,
        idUsuario: decoded.id_usuario,
        nome: decoded.nome,
        brokerId: decoded.id_regional,
        consultancyId: decoded.id_divisao,
        convanantId: decoded.id_convenio,
        sectorId: decoded.id_setor,
        perfil: decoded.perfil,
      };
    }
  },

  // O VEE VALIDATE NÃO DA SUPORTE A INJEÇÃO DE INSTANCIA DO VALIDATOR ACIMA DO PAI DO COMPONENTE
  /**
   * Busca o validador ancestral no nivel do parent informado
   * @param {*} validatorFilho this.$validator
   * @param {*} objectParent this.$parent
   * @param {*} parent numero de ancestrais acima do pai - EXEMPLO avo = 1
   * @returns
   */
  buscarValidatorAncestral(validatorFilho, objectParent, parent) {
    if (!parent) {
      return validatorFilho;
    }

    let validator = objectParent;

    for (let i = 1; i <= +parent; i++) {
      validator = validator.$parent;
    }

    if (validator.$validator) {
      return validator.$validator;
    }

    return validatorFilho;
  },

  /**
   * Atrasa a execução de uma função por um tempo determinado
   * @param {Function} func Função na qual se quer atrasar a execução
   * @param {number} delay Tempo pelo qual se quer atrasar a execução da função
   * @returns {Function} Função debounced
   */
  debounce(func, delay) {
    let timeoutId;

    return function (...args) {
      const context = this; // Salva o contexto atual
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        func.apply(context, args); // Garante que o contexto seja mantido
      }, delay);
    };
  },

  /**
   * Remove chaves de um objeto que estejam com valor null, undefined, string vazia ou array vazio
   * @param {object} obj Objeto a ser limpo
   * @returns {object} Objeto limpo
   */
  cleanParams(obj = {}) {
    const result = {};
    Object.keys(obj).forEach((key) => {
      const val = obj[key];
      if (val === null || val === undefined) return;
      if (typeof val === 'string' && val.trim() === '') return;
      if (Array.isArray(val) && val.length === 0) return;
      result[key] = val;
    });
    return result;
  },

  /**
   * Verifica se já passou uma quantidade de dias desde um data forncida
   * @param {*} data data
   * @param {*} diff diferança em dias
   * @return {boolean}
   */
  dateDiff(data, diff) {
    let dataObject = data;
    if (typeof data === 'string') {
      dataObject = new Date(dataObject);
    }

    const currentDate = new Date();

    const differenceInMilliseconds = currentDate - dataObject;

    // Converte a diferença para dias
    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);

    // Verifica se já se passaram 10 dias
    return differenceInDays >= diff;
  },

  nameValidate(value, isPersonName = true) {
    if (!value) {
      return false;
    }

    if (value.length < 3) {
      return false;
    }

    if (value.length > 60) {
      return false;
    }

    const cepRegex = /^\d{2}\.\d{3}-\d{3}$/;
    const cep = cepRegex.test(value);

    if (cep) {
      return true;
    }

    if (!isPersonName) {
      return true;
    }

    const containNumberOrSpecialCharRegex = /[\d!@#$%^&*(),.?":{}|<>]/;
    const containNumberOrSpecialChar =
      containNumberOrSpecialCharRegex.test(value);

    if (containNumberOrSpecialChar) {
      return false;
    }

    const name = value.split(' ');

    if (name.length < 2 || name[1] === '') {
      return false;
    }

    return true;
  },

  /**
   * Baixa um arquivo apartir de um link
   * @param {*} window objeto window
   * @param {*} link link do arquivo a ser baixado
   */
  async download(window, link) {
    try {
      const response = await fetch(link);

      if (!response.ok) {
        return { success: false };
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      a.download = response.url.split('/').pop();

      document.body.appendChild(a);
      a.click();

      a.remove();

      return { success: true };
    } catch (error) {
      return { success: false, errorMessage: error.errorMessage };
    }
  },

  /**
   * Baixa um arquivo apartir de um link
   * @param {*} window objeto window
   * @param {*} bffeer buffer do arquivo a ser baixado
   * @param {*} fileName nome do arquivo
   */
  async downloadFromBuffer(window, buffer, fileName) {
    try {
      const blob = new Blob([buffer]);

      if (!blob) {
        return { success: false };
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      return { success: false, errorMessage: error.errorMessage };
    }
  },

  getAutoProductExtraLabel(item) {
    if (!item.values) {
      return '';
    }
    let extraText = '';
    if (item.grouping === PRODUCTS_GROUPING.COMPREHENSIVE) {
      extraText += ` de ${this.formataReal(item.values.franchise)}`;
    }

    const moneyWithThousandLabel = `R$ ${
      item.unity === 'mil'
        ? item.quantity / 1000
        : this.formataReal(item.quantity)
    } ${item.unity}`;

    if (item.input === 'slider') {
      extraText += ` - ${moneyWithThousandLabel}`;
    }

    if (item.grouping !== PRODUCTS_GROUPING.APP) {
      return extraText;
    }
    if (item.productName.includes('APP')) {
      extraText += ` / passageiro`;
    } else if (item.productName.includes('DMH')) {
      extraText += ` / diária`;
    }

    return extraText;
  },

  getAutoProductLabel(product) {
    if (!product || !product.productName) {
      return '';
    }
    let productName = product.productName;
    if (product.optionName) {
      productName += ` - ${product.optionName}`;
    }
    return productName + this.getAutoProductExtraLabel(product);
  },

  getConfigDateTimePickerDay() {
    return {
      dateFormat: 'd/m/Y',
      locale: Portuguese,
      time_24hr: true,
    };
  },

  getFromLocalStorageByKey(key) {
    return localStorage.getItem(key);
  },

  setInLocalStorageByKey(key, value) {
    return localStorage.setItem(key, value);
  },

  /**
   * Remeve caracteres expecias de uma string
   * EX Â -> A
   * @param {*} stringToSanitize
   * @returns string
   */
  sanitizeString(stringToSanitize) {
    return stringToSanitize
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9._-]/g, '_')
      .replace(/_{2,}/g, '_')
      .trim();
  },
};
